// export const SERVER_URI = "http://localhost:3100/api";

import Constants from "./data/constants";

//PUSHCODEX
// export let SERVER_URI = "https://pushcodex.com/";
// export let NODE_SERVER_URI = "https://pushcodex.com/nodeapi/";
// export let FILES_SERVER_URI = "https://files.pushcodex.com/";

//Makro
// export const SERVER_CONFIG = {
//   SERVER_URI: "https://makro.push-signage.com/",
//   NODE_SERVER_URI: "https://makro.push-signage.com/nodeapi/",
//   FILES_SERVER_URI: "https://makro.push-signage.com/",
//   WARROOM_ACCESS_TOKEN: "Gp4Lx9VtQs2MwYz7RbKnTuFeDaCiXh"
// };

//codex-lb
// export const SERVER_CONFIG = {
//   SERVER_URI: "https://codex-lb.push-signage.com/",
//   NODE_SERVER_URI: "https://codex-lb.push-signage.com/nodeapi/",
//   FILES_SERVER_URI: "https://codex-lb.push-signage.com/",
//   WARROOM_ACCESS_TOKEN: "MCap4nxgPUAZv3auF9pAEFaAGiS4nU"
// };

export const ALL_SERVERS_CONFIG = {
  "makro-uat": {
    server_uri: "https://makro-uat.push-signage.com/",
    api_path: "api_new/v1/",
    node_server_uri: "https://makro-uat.push-signage.com/nodeapi/",
    files_server_uri: "https://makro-uat.push-signage.com/",
    warroom_access_token: "XJt9qLmN4VR1p2dZ73kEoTbHcFy5wQ",
    firebase_config: {
      apiKey: "AIzaSyALjiH89042-xLVhVOVj3nAIH0x4ps-lmg",
      authDomain: "makropushsignage.firebaseapp.com",
      databaseURL:
        "https://makropushsignage-default-rtdb.asia-southeast1.firebasedatabase.app",
      projectId: "makropushsignage",
      storageBucket: "makropushsignage.firebasestorage.app",
      messagingSenderId: "584543867924",
      appId: "1:584543867924:web:0f78ad32865f90c6390301",
      measurementId: "G-7C0QEF2T3L",
    },
  },
  "codex-lb": {
    server_uri: "https://codex-lb.push-signage.com/",
    api_path: "api/v1/",
    node_server_uri: "https://codex-lb.push-signage.com/nodeapi/",
    files_server_uri: "https://codex-lb.push-signage.com/",
    warroom_access_token: "MCap4nxgPUAZv3auF9pAEFaAGiS4nU",
    firebase_config: {
      apiKey: "AIzaSyALjiH89042-xLVhVOVj3nAIH0x4ps-lmg",
      authDomain: "makropushsignage.firebaseapp.com",
      databaseURL:
        "https://makropushsignage-default-rtdb.asia-southeast1.firebasedatabase.app",
      projectId: "makropushsignage",
      storageBucket: "makropushsignage.firebasestorage.app",
      messagingSenderId: "584543867924",
      appId: "1:584543867924:web:0f78ad32865f90c6390301",
      measurementId: "G-7C0QEF2T3L",
    },
  },
  makro: {
    server_uri: "https://makro.push-signage.com/",
    node_server_uri: "https://makro.push-signage.com/nodeapi/",
    files_server_uri: "https://makro.push-signage.com/",
    warroom_access_token: "Gp4Lx9VtQs2MwYz7RbKnTuFeDaCiXh",
    firebase_config: {
      apiKey: "AIzaSyALjiH89042-xLVhVOVj3nAIH0x4ps-lmg",
      authDomain: "makropushsignage.firebaseapp.com",
      databaseURL:
        "https://makropushsignage-default-rtdb.asia-southeast1.firebasedatabase.app",
      projectId: "makropushsignage",
      storageBucket: "makropushsignage.firebasestorage.app",
      messagingSenderId: "584543867924",
      appId: "1:584543867924:web:0f78ad32865f90c6390301",
      measurementId: "G-7C0QEF2T3L",
    },
  },
  dgs: {
    server_uri: "https://dgs.push-signage.com/",
    node_server_uri: "https://dgs.push-signage.com/nodeapi/",
    files_server_uri: "https://dgs.push-signage.com/",
    warroom_access_token: "hJ7kP9wL3zM8qVt2BnXeR6YsDaCfUi",
    firebase_config: {
      apiKey: "AIzaSyCrPXolGvE8ZY3q2hBqH5vX5Iv6Rv2X2hQ",
      authDomain: "dgspushsignage.firebaseapp.com",
      databaseURL:
        "https://dgspushsignage-default-rtdb.asia-southeast1.firebasedatabase.app",
      projectId: "dgspushsignage",
      storageBucket: "dgspushsignage.firebasestorage.app",
      messagingSenderId: "319608283715",
      appId: "1:319608283715:web:311c4d790a03a7bb8c6af6",
      measurementId: "G-5G4VCGPYGP",
    },
  },
  "the1ads-lb": {
    server_uri: "https://the1ads-lb.push-signage.com/",
    node_server_uri: "https://the1ads-lb.push-signage.com/nodeapi/",
    files_server_uri: "https://the1ads-lb.push-signage.com/",
    warroom_access_token: "",
    firebase_config: {
      apiKey: "AIzaSyD1PP-fO7WUlOtRf6HfUtpT3NXd0L4104A",
      authDomain: "the1ads-lb.firebaseapp.com",
      databaseURL:
        "https://the1ads-lb-default-rtdb.asia-southeast1.firebasedatabase.app",
      projectId: "the1ads-lb",
      storageBucket: "the1ads-lb.firebasestorage.app",
      messagingSenderId: "479915966069",
      appId: "1:479915966069:web:2b349d9f23ceae0023023c",
      measurementId: "G-WDPPDZ4PVE",
    },
  },
  "cds-lb": {
    server_uri: "https://cds-lb.push-signage.com/",
    node_server_uri: "https://cds-lb.push-signage.com/nodeapi/",
    files_server_uri: "https://cds-lb.push-signage.com/",
    warroom_access_token: "",
    firebase_config: {
      apiKey: "AIzaSyBRrLYg7iurATQcNdYp77vxUK2tLgIA6yc",
      authDomain: "cds-lb.firebaseapp.com",
      databaseURL:
        "https://cds-lb-default-rtdb.asia-southeast1.firebasedatabase.app",
      projectId: "cds-lb",
      storageBucket: "cds-lb.firebasestorage.app",
      messagingSenderId: "1014209872039",
      appId: "1:1014209872039:web:80801a135486d2d0cbdb82",
      measurementId: "G-88LEVBJ71R",
    },
  },
};

const DGS_CONFIG = {
  server_uri: "https://dgs.push-signage.com/",
  node_server_uri: "https://dgs.push-signage.com/nodeapi/",
  files_server_uri: "https://dgs.push-signage.com/",
  warroom_access_token: "hJ7kP9wL3zM8qVt2BnXeR6YsDaCfUi",
  api_path: "api_new/v1/",
  firebase_config: {
    apiKey: "AIzaSyCrPXolGvE8ZY3q2hBqH5vX5Iv6Rv2X2hQ",
    authDomain: "dgspushsignage.firebaseapp.com",
    databaseURL:
      "https://dgspushsignage-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "dgspushsignage",
    storageBucket: "dgspushsignage.appspot.com",
    messagingSenderId: "319608283715",
    appId: "1:319608283715:web:311c4d790a03a7bb8c6af6",
    measurementId: "G-5G4VCGPYGP",
  },
};
const ZIGNSTACK_CONFIG = {
  server_uri: "https://cds.zignstack.com/",
  api_path: "api_new/v1/",
  node_server_uri: "https://makro-uat.push-signage.com/nodeapi/",
  files_server_uri: "https://cds.zignstack.com/",
  warroom_access_token: "POap4nxgPUsV23auF9pAEFaAHJHDA",
  //  warroom_access_token: "hJ7kP9wL3zM8qVt2BnXeR6YsDaCfUi",
  firebase_config: {
    apiKey: "AIzaSyALjiH89042-xLVhVOVj3nAIH0x4ps-lmg",
    authDomain: "makropushsignage.firebaseapp.com",
    databaseURL:
      "https://makropushsignage-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "makropushsignage",
    storageBucket: "makropushsignage.firebasestorage.app",
    messagingSenderId: "584543867924",
    appId: "1:584543867924:web:0f78ad32865f90c6390301",
    measurementId: "G-7C0QEF2T3L",
  },
};

const THE1ADS_LB_CONFIG = {
  server_uri: "https://the1ads-lb.push-signage.com/",
  node_server_uri: "https://the1ads-lb.push-signage.com/nodeapi/",
  files_server_uri: "https://the1ads-lb.push-signage.com/",
  warroom_access_token: "",
  api_path: "api/v1/",
  firebase_config: {
    apiKey: "AIzaSyD1PP-fO7WUlOtRf6HfUtpT3NXd0L4104A",
    authDomain: "the1ads-lb.firebaseapp.com",
    databaseURL:
      "https://the1ads-lb-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "the1ads-lb",
    storageBucket: "the1ads-lb.firebasestorage.app",
    messagingSenderId: "479915966069",
    appId: "1:479915966069:web:2b349d9f23ceae0023023c",
    measurementId: "G-WDPPDZ4PVE",
  },
};
const CDS_LB_CONFIG = {
  server_uri: "https://cds-lb.push-signage.com/",
  node_server_uri: "https://cds-lb.push-signage.com/nodeapi/",
  files_server_uri: "https://cds-lb.push-signage.com/",
  warroom_access_token: "",
  api_path: "api/v1/",
  firebase_config: {
    apiKey: "AIzaSyBRrLYg7iurATQcNdYp77vxUK2tLgIA6yc",
    authDomain: "cds-lb.firebaseapp.com",
    databaseURL:
      "https://cds-lb-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "cds-lb",
    storageBucket: "cds-lb.firebasestorage.app",
    messagingSenderId: "1014209872039",
    appId: "1:1014209872039:web:80801a135486d2d0cbdb82",
    measurementId: "G-88LEVBJ71R",
  },
};

const MAKROUAT_CONFIG = {
  server_uri: "https://makro-uat.push-signage.com/",
  node_server_uri: "https://makro-uat.push-signage.com/nodeapi/",
  files_server_uri: "https://makro-uat.push-signage.com/",
  warroom_access_token: "XJt9qLmN4VR1p2dZ73kEoTbHcFy5wQ",
  api_path: "api/v1/",
  firebase_config: {
    apiKey: "AIzaSyALjiH89042-xLVhVOVj3nAIH0x4ps-lmg",
    authDomain: "makropushsignage.firebaseapp.com",
    databaseURL:
      "https://makropushsignage-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "makropushsignage",
    storageBucket: "makropushsignage.firebasestorage.app",
    messagingSenderId: "584543867924",
    appId: "1:584543867924:web:0f78ad32865f90c6390301",
    measurementId: "G-7C0QEF2T3L",
  },
};
const CODEXLB_CONFIG = {
  server_uri: "https://codex-lb.push-signage.com/",
  node_server_uri: "https://codex-lb.push-signage.com/nodeapi/",
  files_server_uri: "https://codex-lb.push-signage.com/",
  warroom_access_token: "MCap4nxgPUAZv3auF9pAEFaAGiS4nU",
  firebase_config: {
    apiKey: "AIzaSyALjiH89042-xLVhVOVj3nAIH0x4ps-lmg",
    authDomain: "makropushsignage.firebaseapp.com",
    databaseURL:
      "https://makropushsignage-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "makropushsignage",
    storageBucket: "makropushsignage.firebasestorage.app",
    messagingSenderId: "584543867924",
    appId: "1:584543867924:web:0f78ad32865f90c6390301",
    measurementId: "G-7C0QEF2T3L",
  },
};

const MAKRO_CONFIG = {
  server_uri: "https://makro.push-signage.com/",
  node_server_uri: "https://makro.push-signage.com/nodeapi/",
  files_server_uri: "https://makro.push-signage.com/",
  warroom_access_token: "Gp4Lx9VtQs2MwYz7RbKnTuFeDaCiXh",
  api_path: "api/v1/",
  firebase_config: {
    apiKey: "AIzaSyALjiH89042-xLVhVOVj3nAIH0x4ps-lmg",
    authDomain: "makropushsignage.firebaseapp.com",
    databaseURL:
      "https://makropushsignage-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "makropushsignage",
    storageBucket: "makropushsignage.firebasestorage.app",
    messagingSenderId: "584543867924",
    appId: "1:584543867924:web:0f78ad32865f90c6390301",
    measurementId: "G-7C0QEF2T3L",
  },
};

export const getLogInAPIAction = () => {
  console.log(
    "getLogInAPIAction checkIsAPINew " +
    checkIsAPINew() +
    " " +
    SERVER_CONFIG.API_PATH,
  );
  return SERVER_CONFIG.API_PATH == !checkIsAPINew() ? "login" : "login_new";
};

export const CHECK_LICENSE = false;

export const ALL_PERMISSION_PAGES = [
  "screen",
  "campaign",
  "playlist",
  "media",
  "media_trash",
  "event",
  "widget",
  "brand",
  "brand_media",
  "brand_media_trash",
  "brand_playlist",
  "branch",
  "dashboard",
  "analytics",
  "activitylog",
  "medialog",
  "user",
  "permission",
  "role",
];

// const defaultConfig = DGS_CONFIG;
const defaultConfig = ZIGNSTACK_CONFIG; //DGS_CONFIG
// const defaultConfig = MAKROUAT_CONFIG
export const USE_SCREENS_FROM_WARROOM = false;

export const ENABLE_ACCOUNT_SWITCHING = true; // Set to false to disable account switching functionality in the UI

//DGS
export const SERVER_CONFIG = {
  SERVER_URI: defaultConfig.server_uri,
  NODE_SERVER_URI: defaultConfig.node_server_uri,
  FILES_SERVER_URI: defaultConfig.files_server_uri,
  WARROOM_ACCESS_TOKEN: defaultConfig.warroom_access_token,
  API_PATH: defaultConfig.api_path,
  firebase_config: defaultConfig.firebase_config,
};

export const checkIsAPINew = () => {
  console.log("checkIsAPINew " + SERVER_CONFIG.API_PATH);
  return SERVER_CONFIG.API_PATH == "api_new/v1/";
  // return SERVER_CONFIG.API_PATH == "api/v1/"
};

// export const NODE_SERVER_URI = "http://128.199.223.3:3100/";
// export const SERVER_URI = "https://ptrsp.jelly-beam.com/";
export const LOCAL_SERVER_URI = "http://localhost:3100/api";
export const WARROOM_SERVER_URI = "https://warroom.pushcodex.com/";
export const CODEXLB_SERVER_URI = "https://codex-lb.push-signage.com/";
// export const SUB_FOLDER = "cms_uat";
export const SUB_FOLDER = Constants.BASE_PATH;
export const IS_LOCAL = true;

export const DEFAULT_FFILE_SCALING = "fill";
export const DEFAULT_WIDGET_SCALING = "cover";
export const DEFAULT_MUTED = true;

export const USE_CAMPAIGN_SYNC = false;

// URL where users can download the signage player app for their display device.
// TODO: Replace with the actual player download link (e.g. Google Play listing).
export const PLAYER_DOWNLOAD_URL = "";
